import { Banner } from '../banner/Banner';

const bannerContent = {
    header: 'Serie-junkie? Da er dette ferien for deg!',
    text: 'Legg ferien dit favorittserien din er spilt inn, og gjenopplev de beste serieøyeblikkene utenfor TV-skjermen.',
    callToAction: 'Sjekk destinasjonene',
    link: 'https://www.finn.no/reise/artikler/tips/tv-ferie-legg-ferien-til-favorittseriens-innspillingssted',
    img: {
        src: 'https://finn-content-hub.imgix.net/bilder/GettyImages-155601850-2.jpg?auto=format,compress&fit=crop&crop=focalpoint&fp-x=0.7319&fp-y=0.4714&fp-z=1.1&w=470&h=300',
        width: 470,
        height: 300,
        alt: '',
    },
};

export const FrontpageBanner = () => {
    const { header, text, callToAction, link, img } = bannerContent;

    return <Banner header={header} text={text} callToAction={callToAction} link={link} imgType="img" img={img} />;
};
